import store from '../vuex/store'

const beforeEach = (to, from, next) => {
  let loggedUser = store.getters.getUser
  let selectedCompany = store.getters.getCompany
  if (!to.matched.length) {
    if (loggedUser.cpf) {
      next({ path: '/' })
    } else {
      next({ path: '/login' })
    }
  } else {
    if (to.meta.requiresLogin && !loggedUser.cpf) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
    if (to.meta.requiresCompany && !selectedCompany.cpfCnpj) {
      next({
        path: '/setcompany',
        query: {
          redirect: to.fullPath
        }
      })
    }
    if (to.meta.requiresLogin && selectedCompany.nivel) {
      if (to.meta.permissions.some(x => x === selectedCompany.nivel.id) || to.meta.permissions.length === 0) {
        next()
      } else {
        console.error('Você não tem permissão para acessar esse módulo.')
        next({ path: '/' })
      }
    } else {
      next()
    }
  }
}

export default beforeEach



// WEBPACK FOOTER //
// ./src/router/beforeEach.js